module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_7042.3cab2be6.png";